// default = true allows for showing on the initial Profile Builder Questions list
// each question has an "i" object member that maps to the actual question.
// storing questions uses the i-selected.
// for "Are you indoorsy or outdoorsy?" that you specify as "Very Indoorsy", you would
// map 0-5

module.exports = [
  {
    i: 0,
    type: "scale0-5", 
    default: true,
    question: "Are you indoorsy or outdoorsy?", 
    leftText: "Very Outdoorsy", 
    rightText: "Very Indoorsy", 
    // in the format of an array because of the range slider component requirement
    // svelte-range-slider-pips
    selected: [0], 
    answers: [
      "Very Outdoorsy", 
      "Somewhat Outdoorsy", 
      "Neutral", 
      "Somewhat Indoorsy", 
      "Very Indoorsy"
    ], 
  },
  
  {
    i: 1,
    type: "scale0-5", 
    default: true,
    question: "Do you consider yourself an introvert or extrovert?", 
    leftText: "Very Extroverted", 
    rightText: "Very Introverted", 
    selected: [0], 
    answers: [
      "Very Extroverted", 
      "Somewhat Extroverted", 
      "Neutral", 
      "Somewhat Introverted", 
      "Very Introverted"
    ], 
  },
  
  {
    i: 2,
    type: "scale0-5", 
    default: true,
    question: "Do you identify liberal or conservative?", 
    leftText: "Very Liberal", 
    rightText: "Very Conservative", 
    selected: [0], 
    answers: [
      "Very Liberal", 
      "Somewhat Liberal", 
      "Centrist", 
      "Somewhat Conservative", 
      "Very Conservative"
    ], 
  },
  
  {
    i: 3,
    type: "scale0-5", 
    default: true,
    question: "Are you religious?", 
    leftText: "Not Religious", 
    rightText: "Very Religious", 
    selected: [0], 
    answers: [
      "Not Religious", 
      "A Little Religious", 
      "Somewhat Religious", 
      "Definitely Religious", 
      "Very Religious"
    ], 
  },
  
  {
    i: 4,
    type: "scale0-5", 
    default: true,
    question: "Do you like to travel?", 
    leftText: "Nope", 
    rightText: "Love It!", 
    selected: [0], 
    answers: [
      "Nope", 
      "A Little", 
      "Somewhat", 
      "Definitely", 
      "Love It!"
    ], 
  },
  
  {
    i: 5,
    type: "scale0-2", 
    default: false,
    question: "Are you part of the LGBTQIA+ community?", 
    leftText: "Yes", 
    rightText: "No", 
    selected: [0], 
    answers: [
      "Yes", 
      "Neutral", 
      "No"
    ], 
  },
  
  
]